<div class="cg-filter-text-input">
  <input
    #textInput
    class="cg-filter-text-input__input"
    [value]="text"
    data-test="filter-input"
    type="text"
    [placeholder]="placeholder"
    [class.cg-filter-text-input__input--on-dark]="darkBg"
    (keyup)="inputChange.emit(textInput.value)"
  />
  <div
    *ngIf="textInput.value !== ''"
    class="cg-filter-text-input__clear"
    data-test="filter-clear"
    (click)="clearInput()"
  >
    clear
  </div>
  <!-- <cigna-icon
    type="search"
    class="cg-filter-text-input__icon cg-color-gray-60"
    style="height:14px;width:14px;"
  ></cigna-icon> -->
</div>
